import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import Field from '@starbucks-web/pattern-library/lib/components/field';
import shouldDisplayError from '@starbucks-web/pattern-library/lib/components/form-container/should-display-error';

import messages from './messages';
import sharedMessages from 'shared/app/components/text-area/messages.js';
import { formMessages } from 'shared/app/messages/user-form-input.js';

const Sender = ({
  senderName,
  setSenderNameValue,
  senderEmail,
  setSenderEmailValue,
}) => {
  const { formatMessage } = useIntl();
  const emailError = senderEmail?.errorDetails?.existence
    ? formatMessage(messages.senderEmailMissing)
    : formatMessage(messages.emailError);

  return (
    <React.Fragment>
      <Field
        {...senderName?.input}
        autoComplete="name"
        data-e2e="senderName"
        error={shouldDisplayError(senderName)}
        errorMessage={formatMessage(messages.senderNameError)}
        maxLength={40}
        maxLengthAriaMessage={formatMessage(formMessages.maxLengthAriaMessage)}
        onFocus={(e) => {
          setSenderNameValue(e.target.value);
        }}
      >
        <FormattedMessage {...messages.senderNameLabel} />
        <span className="hiddenVisually">
          ,{' '}
          <FormattedMessage
            {...sharedMessages.characterLimitLabel}
            values={{ maxCharacterCount: 40 }}
          />
        </span>
      </Field>
      <Field
        {...senderEmail?.input}
        autoComplete="email"
        data-e2e="senderEmail"
        error={shouldDisplayError(senderEmail)}
        errorMessage={emailError}
        maxLength={50}
        maxLengthAriaMessage={formatMessage(formMessages.maxLengthAriaMessage)}
        onFocus={(e) => {
          setSenderEmailValue(e.target.value);
        }}
        type="email"
      >
        <FormattedMessage {...messages.senderEmailLabel} />
        <span className="hiddenVisually">
          ,{' '}
          <FormattedMessage
            {...sharedMessages.characterLimitLabel}
            values={{ maxCharacterCount: 50 }}
          />
        </span>
      </Field>
    </React.Fragment>
  );
};

export default Sender;
